function tab() {
	const tabs = document.getElementsByClassName('p-tab');
  for(let i = 0; i < tabs.length; i++) {
    tabs[i].addEventListener('click', tabSwitch);
  }

  function tabSwitch(){
		document.querySelector('.p-tab[aria-selected="true"]').setAttribute('aria-selected', 'false');
		this.setAttribute('aria-selected', true);
    document.querySelector('.p-tab-panel[aria-hidden="false"]').setAttribute('aria-hidden', 'true');
    const arrayTabs = Array.prototype.slice.call(tabs);
    const index = arrayTabs.indexOf(this);
    document.getElementsByClassName('p-tab-panel')[index].setAttribute('aria-hidden', 'false');
  };
}

function fixedItemKuramoto() {
  var $fixedItem = $('.js-fixed-item');
  $(window).on('scroll', function () {
    var $trigger = $('.js-trigger').offset().top;
    var scrollTop = $(window).scrollTop();
    var scrollPosition = window.innerHeight + scrollTop;
    var footHeight = $('.l-footer').offset().top;

    if (scrollTop >= $trigger) {
      $fixedItem.addClass('is-fixed');
      $fixedItem.removeClass('is-fixed-close');
    } else {
      if ($fixedItem.hasClass('is-fixed')) {
        $fixedItem.removeClass('is-fixed');
        $fixedItem.addClass('is-fixed-close');
      }
    }

    if (scrollPosition >= footHeight) {
      $fixedItem.removeClass('is-fixed');
      $fixedItem.addClass('is-fixed-close');
    }
  });
}

$(window).on('load',() => {
	tab();
	fixedItemKuramoto();
});
